<template>
  <Cfg>
    <slot>
      <div class="animated fadeIn">
        <Alerts ref="alert"/>
        <Forms ref="frmGroup"
          :title="this.$lang.Stage.TitleForm"
          :showHelp="true"
          :showClearButton="true"
          :showSaveButton="true"
          v-on:Clear="onClear"
          v-on:Save="onSave">
          <div class="form-group row">
            <div class="col-md-6">
              <label for="cbxSinisterStage"><small class="text-danger">*</small> {{$lang.Stage.LabelArea}}:</label>
              <div class="input-group">
                <b-form-select v-model="form.areaID.value"
                              :options="form.areaID.options"
                              :state="form.areaID.state"
                              class="mb-3" >
                   <template slot="first">
                    <!-- this slot appears above the options from 'options' prop -->
                    <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                  </template>
                </b-form-select>
              </div>
            </div>
            <div class="col-md-6">
              <label for="txtName"><small class="text-danger">*</small> {{$lang.Stage.LabelName}}:</label>
              <div class="input-group">
                <b-form-input type="text"
                              :placeholder="$lang.Stage.PlaceholderEnterName"
                              v-model="form.name.value"
                              :size="form.name.maxlength"
                              :required="form.name.required"
                              :state="form.name.state"></b-form-input>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-6">
              <label for="txtCNPJ"><small class="text-danger">*</small> {{$lang.Stage.LabelMnemonic}}:</label>
              <div class="input-group">
                <b-form-input type="text"
                              :placeholder="$lang.Stage.PlaceholderEnterMnemonic"
                              v-model="form.mnemonic.value"
                              :size="form.mnemonic.maxlength"
                              :required="form.mnemonic.required"
                              :state="form.mnemonic.state"></b-form-input>
              </div>
            </div>
            <div class="col-md-6">
              <label for="txtName"> {{$lang.Stage.LabelColor}}:</label>
              <div class="input-group">
                <b-form-input type="text"
                              :placeholder="$lang.Stage.PlaceholderEnterColor"
                              v-model="form.color.value"
                              :size="form.color.maxlength"
                              :required="form.color.required"
                              :state="form.color.state"></b-form-input>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-12">
              <label for="txtDescription"> {{$lang.Stage.LabelDescription}}:</label>
              <b-form-textarea id="txtDescription"
                          name="txtDescription"
                          v-model.trim="form.description.value"
                          :placeholder="$lang.Stage.PlaceholderEnterDescription"
                          :rows="form.description.rows"
                          :size="form.description.maxlength"
                          :noResize="form.description.noResize"></b-form-textarea>
              <small class="small-help"><i class="fa fa-info-circle"></i> <span v-html="FieldSizeTip"></span>.</small>
            </div>
          </div>
        </Forms>

        <Tables ref="tableGrid"
            :columns="[$lang.Stage.DataTable.Name,
                       $lang.Stage.DataTable.Area,
                       $lang.Common.DataTable.Status,
                       $lang.Common.DataTable.ActionDate,
                       $lang.Common.DataTable.AccountAction,
                       $lang.Common.DataTable.Actions]"
            :showSearch="true"
            :showPrint="true"
            :showDownload="true"
            :showFullscreen="true"
            v-on:Load="onLoad">
          <tr v-for="obj in this.objList" v-bind:key="obj.id">
            <TableColumn :IsText="true"     v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.name" />
            <TableColumn :IsText="true"     v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.area.name" />
            <TableColumn :IsStatus="true"   v-on:Edit="onEdit(obj)" :status="obj.status" />
            <TableColumn :IsDatetime="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.dateUpdate" />
            <TableColumn :IsText="true"     v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.accountUserNameUpdate" />
            <TableColumn :IsActionsButtons="true" v-on:Change="onChange(obj)" v-on:Delete="onDelete(obj)" :status="obj.status" />
          </tr>
        </Tables>
      </div>
    </slot>
  </Cfg>
</template>

<script>
import Stage from './stage.js'

export default Stage
</script>



// WEBPACK FOOTER //
// src/views/private/configuration/stage/stage.vue